<template>
  <div :id="'collapse'+index" class="collapse show" :aria-labelledby="'heading'+index">
    <!-- if measurements not empty, render -->
    <div class='card-body'>
      <ul class='list-group'>
        <li class="list-group-item body__list"
            v-for="datum in renderData"
            v-bind:key="datum.measure.id">
          <p class="row body__desc">
            <text-highlight :queries="keywords"
                            class="col-md-9 col-9 pl-md-0 pl-0">
              {{ datum.measure.desc }}
            </text-highlight>
            <span v-if="datum.measure.value && datum.measure.value.length < 50" class="col-md-3 col-3 body__desc__value">
              {{ datum.measure.value }} {{ datum.measure.units }}
            </span>
            <span v-else class="w-100 text-lowercase">
              {{ datum.measure.value }} {{ datum.measure.units }}
            </span>
          </p>
          <watch-button-measure
            :procCcd="procedure.codes[0]"
            :measCcd="datum.measure.ccd"
          />
        </li>
     </ul>
    </div>
  </div>
</template>

<script>
import WatchButtonMeasure from '@/components/private-layouts/_partials/watch/WatchButtonMeasure';
import { 
  getAllMeasByProcId 
} from '@/data/getters';
import { mapGetters } from "vuex";

export default {
  name: "procedure-body",
  components: {
    'watch-button-measure': WatchButtonMeasure,
  },
  props: {
    procedure: {},
    index: null,
    keywords: Array,
  },
  data() {
    return {
      renderData : []
    };
  },
  created() {
    let result = [];
    let procids = this.procedure.ids;
    for(let pidx = 0;pidx < procids.length;pidx++) {
      let procid = procids[pidx];
      let measures = getAllMeasByProcId(procid,this.allData);
      if(measures && measures.length) {
        for(let midx = 0;midx < measures.length;midx++) {
          let measure = measures[midx];
          result.push({measure,procid});
        }
      }
    }
    this.renderData = result;
  },
  beforeDestroy() {
    delete this.renderData;
    this.renderData = null;
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData'
    })
  },
  methods: {
    getAllMeasures() {
      return getAllMeasByProcId(this.procedure.id, this.allData);
    }
  }
}
</script>

<style scoped lang="scss">
  .list-group-item {
    padding: 0;
    border: none;
    display: flex;
    align-items: center;
    width: 100%;
    background-color: transparent;

    &:nth-child(odd) {
      background-color: rgba(0, 0, 0, 0.03);
    }

    ::v-deep .icon-container {
      flex-shrink: 0;
      float: none;
      position: static;
      margin-left: auto;
      height: auto;

      .icon__btn {
        margin-top: 0;
      }

      .icon__btn--small {
        position: static;
        transform: none;
        margin-left: 0;
        padding-top: 0.3rem;
        padding-bottom: 0.3rem;
      }
    }
  }

  .card-body {
    font-size: 0.9rem;
    color: lighten(#000, 20%);
    padding: 0;
    width: 100%;
  }

  .list-group {
    width: 100%;
  }

  .collapse {
    width: 100%;
  }

  .collapsing {
    width: 100%;
  }

  .body__desc {
    flex: 1;
    min-width: 0;
    width: auto;
    padding: 0.7rem 0;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;

    .body__desc__value {
      text-align: right;
      text-transform: lowercase;
    }
  }
</style>
